import React from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import Avatar from '@material-ui/core/Avatar';
import CloseIcon from '@material-ui/icons/Close';
import { Link } from '@reach/router';
import { Query, withApollo } from 'react-apollo';

import classes from './chat.module.scss';
import { GET_CHAT, GET_CHATS } from '../../queries';
import MessageList from './message-list';
import AddMessage from './add-message';
import gql from 'graphql-tag';

const MARK_AS_READ = gql`
  mutation($chatId: String!, $timestamp: String!) {
    markAsRead(chatId: $chatId, timestamp: $timestamp)
  }
`;

class Chat extends React.PureComponent<any> {
  private interval;

  public componentDidMount() {
    // TODO: Replace interval with action-based mechanism
    this.interval = setInterval(() => {
      this.props.client.mutate({
        mutation: MARK_AS_READ,
        variables: { chatId: this.props.id, timestamp: new Date() },
        update: store => {
          const data = store.readQuery({ query: GET_CHATS });
          if (!data) return;
          const index = data.userChats.findIndex(
            chat => chat.id === this.props.id
          );
          data.userChats[index].unread = 0;
          store.writeQuery({ query: GET_CHATS, data });
        }
      });
    }, 2000);
  }

  public componentWillUnmount(): void {
    clearInterval(this.interval);
  }

  public render() {
    const { id } = this.props;
    return (
      <div className={classes.chatContainer}>
        <Query query={GET_CHAT} variables={{ id }}>
          {({ loading, error, data }) => {
            if (loading) {
              return (
                <div style={{ textAlign: 'center' }}>
                  <CircularProgress />
                </div>
              );
            }
            if (error) return <div>Error fetching messages</div>;

            return (
              <>
                <Card className={classes.card}>
                  <CardHeader
                    avatar={
                      <Link
                        to={'/product/' + data.chat.product.id}
                        className={classes.productName}
                      >
                        <Avatar
                          alt={data.chat.product.name}
                          src={data.chat.product.image}
                        />
                      </Link>
                    }
                    action={
                      <Link to="/mailbox" className={classes.productName}>
                        <IconButton aria-label="close">
                          <CloseIcon />
                        </IconButton>
                      </Link>
                    }
                    title={
                      <Link
                        to={'/product/' + data.chat.product.id}
                        className={classes.productName}
                      >
                        {data.chat.product.name}
                      </Link>
                    }
                  />
                </Card>
                <MessageList
                  chat={data.chat.messages}
                  me={data.chat.me}
                  id={id}
                />
              </>
            );
          }}
        </Query>
        <AddMessage id={id} />
      </div>
    );
  }
}

export default withApollo(Chat);
